import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from './theme-context';
import { LocaleProvider } from './locale-context';
import { RouterProvider } from './router';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider><ThemeProvider>
      <LocaleProvider><App /></LocaleProvider>
    </ThemeProvider></RouterProvider>
  </React.StrictMode>
);
